/**
 * Error thrown when Analytix initialization fails
 */
export class AnalytixInitializeError extends Error {
  constructor(message: unknown) {
    let msg: string
    if (typeof message === 'string') {
      msg = message
    } else if (message instanceof Error) {
      msg = message.message
    } else {
      msg = String(message)
    }
    super(`Failed to initialize Analytix: ${msg}`)
  }
}

/**
 * Error thrown when Analytix instance is enabled, but not initialized
 */
export class AnalytixNotInitializedError extends Error {
  constructor() {
    super('Analytix instance is not initialized')
  }
}

/**
 * Error thrown when sending an Analytix event fails
 */
export class AnalytixSendEventError extends Error {
  constructor(eventName: string, error: unknown) {
    let msg: string
    if (typeof error === 'string') {
      msg = error
    } else if (error instanceof Error) {
      msg = error.message
    } else {
      msg = String(error)
    }
    super(`Analytix event ${eventName} failed to send: ${msg}`)
  }
}
